<template>
  <div class="mt-4">
    <el-dialog title="" :visible.sync="centerDialogVisible" width="30%" center>
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">
          Setup Your Payment Gateway
        </h3></template
      >
      <div>
        <div class="">
          <div class="relative mb-2">
            <small class="fsize12 bg-white text-dark">Client Id </small>
            <el-input
              placeholder=""
              v-model.trim="clientId"
              class="rounded-xl mt-2"
            />
          </div>
          <div class="relative">
            <small class="fsize12 bg-white text-dark">Client Secret </small>
            <el-input
              placeholder=""
              v-model.trim="clientSecret"
              class="rounded-xl mt-2"
            />
          </div>
        </div>
        <div class="flex gap-6 justify-center">
          <button
            class="mt-8 px-8 py-3 bg-primary border-0 cursor-pointer rounded-full text-white"
            @click="handleAddGateway()"
          >
            Submit
          </button>
          <button
            class="mt-8 px-8 py-3 bg-dark border-0 cursor-pointer rounded-full text-white"
            @click="() => (this.centerDialogVisible = false)"
          >
            Cancel
          </button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="centerDialogVisiblePayu"
      width="30%"
      center
    >
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">
          Setup Your Payment Gateway
        </h3></template
      >
      <div>
        <div class="">
          <div class="relative mb-2">
            <small class="fsize12 bg-white text-dark">PayU Key </small>
            <el-input
              placeholder=""
              v-model.trim="key"
              class="rounded-xl mt-2"
            />
          </div>
          <div class="relative">
            <small class="fsize12 bg-white text-dark">PayU Salt </small>
            <el-input
              placeholder=""
              v-model.trim="salt"
              class="rounded-xl mt-2"
            />
          </div>
        </div>
        <div class="flex gap-6 justify-center">
          <button
            class="mt-8 px-8 py-3 bg-primary border-0 cursor-pointer rounded-full text-white"
            @click="handleAddGateway()"
          >
            Submit
          </button>
          <button
            class="mt-8 px-8 py-3 bg-dark border-0 cursor-pointer rounded-full text-white"
            @click="() => (this.centerDialogVisiblePayu = false)"
          >
            Cancel
          </button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="centerDialogVisibles" width="30%" center>
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">Success</h3></template
      >
      <div>
        <div class="p-5">
          <div class="text-center">
            <h2 class="fsize22 bg-white font-bold text-dark">Success!</h2>
            <h5 class="fsize12 bg-white text-dark mt-2">
              Payment Gateway added.
            </h5>
          </div>
        </div>
        <!-- <div class="flex gap-6 justify-center">
          <button
            class="mt-8 px-8 py-3 bg-primary border-0 cursor-pointer rounded-full text-white"
          >
            Submit
          </button>
          <button
            class="mt-8 px-8 py-3 bg-dark border-0 cursor-pointer rounded-full text-white"
          >
            Cancel
          </button>
        </div> -->
      </div>
    </el-dialog>
    <div class="w-full p-5 bg-white">
      <h2 class="text-xl mb-0 font-semibold">Set up Other Payment Gateway</h2>
    </div>
    <div class="py-4">
      <!-- <div class="grid grid-cols-3 gap-8 mt-3">
        <div class="p-4 elshadow rounded-12px bg-white">
          <div class="flex w-full justify-start items-center gap-2 mt-2">
            <div class="flex w-1/5 justify-center">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Admin/Payments/Image 1.png"
                class="pm-imgw"
              />
            </div>
            <div class="w-4/5">
              <h2 class="text-dark fsize16 font-semibold">Razorpay</h2>
            </div>
          </div>
          <div class="mt-4 pb-2 px-4">
            <p class="text-8f8f8f text-sm leading-3 mb-0">
              Razorpay is a faster, safer way to send money, make a online
              payment, account.
            </p>
          </div>
          <div class="border-topy w-full flex items-center gap-3 pt-4">
            <vs-button
              class="bg-gtr border-0 text-white lg:py-3 font-normal text-sm md:py-3 py-1 px-6"
              @click="centerDialogVisible = true"
            >
              Add
            </vs-button>
            <a href="https://payu.in/" target="_blank">
              <p class="text-primary text-md mb-0">Learn More</p></a
            >
          </div>
        </div>
        <div class="p-4 elshadow rounded-12px bg-white">
          <div class="flex w-full justify-start items-center gap-2 mt-2">
            <div class="flex w-1/5 justify-center">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Admin/Payments/image 4.png"
                class="pm-imgw"
              />
            </div>
            <div class="w-4/5">
              <h2 class="text-dark fsize16 font-semibold">PayU</h2>
            </div>
          </div>
          <div class="mt-4 pb-2 px-4">
            <p class="text-8f8f8f text-sm leading-3 mb-0">
              PayU is a faster, safer way to send money, make a online payment,
              account.
            </p>
          </div>
          <div class="border-topy w-full flex items-center gap-3 pt-4">
            <vs-button
              class="bg-gtr border-0 text-white lg:py-3 font-normal text-sm md:py-3 py-1 px-6"
              @click="centerDialogVisible = true"
            >
              Add
            </vs-button>
            <a href="https://payu.in/" target="_blank">
              <p class="text-primary text-md mb-0">Learn More</p></a
            >
          </div>
        </div>
        <div class="p-4 elshadow rounded-12px bg-white">
          <div class="flex w-full justify-start items-center gap-2 mt-2">
            <div class="flex w-1/5 justify-center">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Admin/Payments/image 2.png"
                class="pm-imgw"
              />
            </div>
            <div class="w-4/5">
              <h2 class="text-dark fsize16 font-semibold">Cashfree</h2>
            </div>
          </div>
          <div class="mt-4 pb-2 px-4">
            <p class="text-8f8f8f text-sm leading-3 mb-0">
              Cashfree is a faster, safer way to send money, make a online
              payment, account.
            </p>
          </div>
          <div class="border-topy w-full flex items-center gap-3 pt-4">
            <vs-button
              class="bg-gtr border-0 text-white lg:py-3 font-normal text-sm md:py-3 py-1 px-6"
              @click="centerDialogVisible = true"
            >
              Add
            </vs-button>
            <a href="https://www.cashfree.com/" target="_blank">
              <p class="text-primary text-md mb-0">Learn More</p></a
            >
          </div>
        </div>
        <div class="p-4 elshadow rounded-12px bg-white">
          <div class="flex w-full justify-start items-center gap-2 mt-2">
            <div class="flex w-1/5 justify-center">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Admin/Payments/image 3.png"
                class="pm-imgw"
              />
            </div>
            <div class="w-4/5">
              <h2 class="text-dark fsize16 font-semibold">Paytm</h2>
            </div>
          </div>
          <div class="mt-4 pb-2 px-4">
            <p class="text-8f8f8f text-sm leading-3 mb-0">
              Paytm is a faster, safer way to send money, make a online payment,
              account.
            </p>
          </div>
          <div class="border-topy w-full flex items-center gap-3 pt-4">
            <vs-button
              class="bg-gtr border-0 text-white lg:py-3 font-normal text-sm md:py-3 py-1 px-6"
              @click="centerDialogVisible = true"
            >
              Add
            </vs-button>
            <a href="https://paytm.com/" target="_blank">
              <p class="text-primary text-md mb-0">Learn More</p></a
            >
          </div>
        </div>
      </div> -->
      <div class="grid grid-cols-3 gap-8 mt-3">
        <div v-for="gateway in otherPaymentGateway" :key="gateway._id">
          <div class="p-4 elshadow rounded-12px bg-white">
            <div class="flex w-full justify-start items-center gap-2 mt-2">
              <div class="flex w-1/5 justify-center">
                <img
                  :src="
                    gateway.logo
                      ? getImage(gateway.logo)
                      : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Admin/Payments/Image 1.png'
                  "
                  class="pm-imgw"
                  :alt="gateway.name"
                />
              </div>
              <div class="w-4/5">
                <h2 class="text-dark fsize16 font-semibold">
                  {{ gateway.name }}
                </h2>
              </div>
            </div>
            <div class="mt-4 pb-2 px-4">
              <p class="text-8f8f8f text-sm leading-3 mb-0">
                {{ gateway.description }}
              </p>
            </div>
            <div class="border-topy w-full flex items-center gap-3 pt-4">
              <vs-button
                :disabled="
                  gateway.name !== 'Razorpay' && gateway.name !== 'PayU'
                "
                class="bg-gtr border-0 text-white lg:py-3 font-normal text-sm md:py-3 py-1 px-6"
                @click="open(gateway)"
              >
                Add
              </vs-button>
              <a :href="gateway.link" target="_blank">
                <p class="text-primary text-md mb-0">Learn More</p></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      clientId: "",
      clientSecret: "",
      key: "",
      salt: "",
      provider: "",
      selectedGateway: {},
      centerDialogVisible: false,
      centerDialogVisibles: false,
      centerDialogVisiblePayu: false,
      otherPaymentGateway: [
        // {
        //   _id: 1,
        //   logo: "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Admin/Payments/Image 1.png",
        //   name: "Razorpay",
        //   link: "https://razorpay.com/",
        //   description:
        //     "Razorpay is a faster, safer way to send money, make a online payment, account.",
        // },
        // {
        //   _id: 2,
        //   logo: "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Admin/Payments/image 2.png",
        //   name: "Cashfree",
        //   link: "https://www.cashfree.com/",
        //   description:
        //     "Cashfree is a faster, safer way to send money, make a online payment, account.",
        // },
        // {
        //   _id: 3,
        //   logo: "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Admin/Payments/image 3.png",
        //   name: "Paytm",
        //   link: "https://paytm.com/",
        //   description:
        //     "Paytm is a faster, safer way to send money, make a online payment, account.",
        // },
        // {
        //   _id: 4,
        //   logo: "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Admin/Payments/image 4.png",
        //   name: "PayU",
        //   link: "https://payu.in/",
        //   description:
        //     "PayU is a faster, safer way to send money, make a online payment, account.",
        // },
      ],
    };
  },
  computed: {
    ...mapState("brandProfile", ["brandProfile"]),
    // ...mapState("payment", ["razorpay"]),
    ...mapState("admin", ["login"]),
    ...mapState("user", {
      selectedProject: "selectedProject",
    }),
  },
  methods: {
    getImage(img) {
      return `${this.$imageURL}/${img}`;
    },
    open(gateway) {
      // console.log(gateway);
      if (gateway.name == "Razorpay") {
        this.selectedGateway = gateway;
        this.provider = gateway.name;
        this.centerDialogVisible = true;
        this.centerDialogVisibles = false;
      } else if (gateway.name == "PayU") {
        this.selectedGateway = gateway;
        this.provider = gateway.name;
        this.centerDialogVisiblePayu = true;
        this.centerDialogVisibles = false;
      }
    },
    close() {
      this.centerDialogVisible = false;
      this.centerDialogVisibles = true;
    },
    reset() {
      this.selectedGateway = {};
      this.clientId = "";
      this.clientSecret = "";
      this.provider = "";
    },
    async handleAddGateway() {
      let payload = {
        logo: this.selectedGateway.logo,
        provider: this.selectedGateway.name,
        verified: "Pending",
        status: "Pending",
        isActive: false,
        adminId: this.login._id,
      };

      if (this.selectedGateway.name == "Razorpay") {
        Object.assign(payload, { clientId: this.clientId });
        Object.assign(payload, { clientSecret: this.clientSecret });
      }
      if (this.selectedGateway.name == "PayU") {
        Object.assign(payload, { key: this.key });
        Object.assign(payload, { salt: this.salt });
      }

      let data = await this.$store.dispatch("Payment/createGateway", payload);

      if (data.code === 200) {
        this.getGateway();
        this.reset();
        this.close();
      }
    },
    async getGateway() {
      let data = await this.$store.dispatch("Payment/getGateway");
    },
    async init() {
      let data = await this.$store.dispatch("billing/getPaymentGateway");
      console.log(data.data.Data);
      this.otherPaymentGateway = data.data.Data;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
